<template>
  <v-btn-toggle
    :model-value="preference"
    mandatory
    divided
    variant="outlined"
    density="comfortable"
    color="primary"
    aria-label="Thème d'affichage"
    @update:model-value="select"
  >
    <v-btn v-for="option in options" :key="option.value" :value="option.value" :title="option.label">
      <v-icon :start="!compact">{{ option.icon }}</v-icon>
      <span v-if="!compact">{{ option.label }}</span>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
  import { getThemePreference, setThemePreference } from "@/services/Theme.service";

  // Light / dark / device theme choice, applied right away and remembered on this device.
  export default {
    name: "ThemeSelector",
    props: {
      // Icons only, for narrow places such as the account menu
      compact: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      options: [
        { value: "light", label: "Clair", icon: "mdi-white-balance-sunny" },
        { value: "dark", label: "Sombre", icon: "mdi-weather-night" },
        { value: "system", label: "Appareil", icon: "mdi-theme-light-dark" },
      ],
    }),
    computed: {
      preference() {
        return getThemePreference(this.$vuetify.theme);
      },
    },
    methods: {
      select(preference) {
        setThemePreference(this.$vuetify.theme, preference);
      },
    },
  };
</script>
